import React from "react";
import { Box, Grid, Slide, Typography, CardMedia } from "@mui/material";
import SwipeableTextMobileStepper from "./MobileStepper";
import { SecondaryStyle } from "../fonts";

import LDT1 from "../assets/Page7LDT1.webp";
import LDT2 from "../assets/Page7LDT2.webp";
import LB from "../assets/Page7LB.webp";
import R1 from "../assets/Page7RA1.webp";
import R2 from "../assets/Page7RA2.webp";

//@ts-ignore
import LDB from "../assets/Page7LDB.mp4";

const carousel1Images = [LDT1, LDT2];
const carousel2Images = [R1, R2];

const Page7 = (props) => {
  const { checked, isReverse } = props;

  return (
    <Slide
      direction={isReverse ? "right" : "left"}
      in={checked}
      timeout={{
        enter: 1750,
        exit: 1750,
      }}
    >
      <Box
        sx={{
          width: "100vw",
          height: "100vh",
          overflow: { xs: "auto", sm: "hidden" },
        }}
      >
        <Grid container sx={{ height: "100%" }} id="scrollTarget">
          {/* First Half */}
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{
                height: "100%",
                borderTop: { xs: "1vh solid #fff", sm: "none" },
              }}
            >
              {/* LA/LD */}
              <Grid item xs={12} sm={6}>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    height: "100%",
                    width: "100%",
                    maxHeight: { xs: "100%", sm: "50vh" },
                  }}
                >
                  {/* LC */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderBottom: ".5vh solid #fff",

                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },

                      maxHeight: { xs: "100%", sm: "50vh" },
                    }}
                  >
                    <Box
                      sx={{
                        height: { xs: "36vh", sm: "24.1vh" },
                        borderRadius: { xs: "16px", sm: "0vh" },

                        borderBottom: {
                          xs: ".5vh solid #fff",
                          sm: ".5vh solid #fff",
                        },
                      }}
                    >
                      <SwipeableTextMobileStepper images={carousel1Images} />
                    </Box>

                    <Box
                      sx={{
                        height: { xs: "46vh", sm: "24.7vh" },

                        borderRadius: { xs: "16px", sm: "0vh" },
                        borderTop: ".4vh solid #fff",
                      }}
                    >
                      <CardMedia
                        component={"video"}
                        sx={{
                          borderRadius: { xs: "16px", sm: "0vh" },
                          height: "100%",
                          objectFit: "cover",
                          objectPosition: "50% 50%",
                        }}
                        src={LDB}
                        autoPlay
                        muted
                        loop
                        playsInline
                      />
                    </Box>
                  </Grid>

                  {/* LB */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      px: { xs: 1.5, md: 1.5, lg: 2, xl: 3 },
                      pb: { xs: 1.5 },
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        ...SecondaryStyle,

                        textAlign: { xs: "justify", sm: "left" },
                        "@media (orientation: landscape)": {
                          fontSize: { xs: "1vw", md: "1vw", lg: "0.95vw" },
                          lineHeight: {
                            xs: "1.5vw",
                            md: "1.5vw",
                            lg: "1.5vw",
                          },
                        },
                        "@media (orientation: portrait)": {
                          fontSize: { xs: "1.7vh", sm: "1vh" },
                          lineHeight: {
                            xs: "2vh",
                            sm: "1.5vh",
                            md: "1.5vh",
                            lg: "1.5vh",
                          },
                          paddingTop: {
                            xs: "1vh",
                            sm: "2vh",
                            md: "2vh",
                            lg: "2vh",
                          },
                        },
                      }}
                    >
                      The outdoor patio offers a tranquil retreat with the
                      perfect blend of greenery and brick hardscaping. Whether
                      you’re hosting family gatherings, enjoying some outdoor
                      dining, or simply relaxing in the peaceful garden, this
                      versatile space adapts effortlessly to your needs. The
                      fenced-in layout provides privacy, while the lush
                      landscaping brings nature right to your doorstep. With a
                      convenient carport and parking for two cars, this patio
                      combines both beauty and practicality, making it an ideal
                      outdoor escape for families or anyone who enjoys
                      low-maintenance outdoor living.
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                item
                xs={12}
                sx={{
                  borderTop: ".5vh solid #fff",
                  borderRadius: { xs: "16px", sm: "0vh" },
                  borderBottom: {
                    xs: ".5vh solid #fff",
                    sm: "none",
                  },
                  borderRight: {
                    xs: "1vh solid #fff",
                    sm: ".5vh solid #fff",
                  },
                  borderLeft: {
                    xs: "1vh solid #fff",
                    sm: "none",
                  },
                  backgroundImage: `url('${LB}')`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  height: {
                    xs: "50vh",
                    sm: "100%",
                  },
                  maxHeight: { xs: "100%", sm: "50vh" },
                }}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              <Grid item xs={12}>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    height: "100%",
                  }}
                >
                  {/* RD/RA */}
                  <Grid
                    container
                    direction={"row"}
                    sx={{
                      height: "100%",
                    }}
                  >
                    <Grid
                      item
                      xs={12}
                      sx={{
                        borderRadius: { xs: "16px", sm: "0vh" },
                        borderTop: {
                          xs: ".5vh solid #fff",
                          sm: "none",
                        },
                        borderLeft: {
                          xs: "1vh solid #fff",
                          sm: ".5vh solid #fffe",
                        },
                        borderBottom: { xs: "1vh solid #fff", sm: "none" },
                        borderRight: {
                          xs: "1vh solid #fff",
                          sm: "none",
                        },
                        height: {
                          xs: "50vh",
                          sm: "100%",
                        },
                      }}
                    >
                      <SwipeableTextMobileStepper images={carousel2Images} />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Slide>
  );
};

export default Page7;
